<template>
    <!-- Карточка пользователя в спике -->
    <div class="bug_card px-4 py-4 list-item-component">
        <div class="vx-row">
            <div class="vx-col w-full flex sm:items-center justify-between sm:flex-row flex-col">
                <div class="flex items-center">
                    <span class="pr-2">{{$t('author')}}</span> {{userName}}
                    <vs-chip class="lg:ml-4" transparent :color="statusColor">{{statusText}}</vs-chip>
                </div>
                <div class="flex items-center" v-if="item.responsible_person && item.responsible_person.user">
                    <span class="pr-2">{{$t('responsible')}}</span>
                    <template v-if="item.responsible_person.user.profile.profileId === user.profileId">
                        <span class="text-danger">{{$t('you')}}</span>
                    </template>
                    <template v-else>
                        {{userName2}}
                    </template>
                </div>
                <div class="flex items-center">
                    <vx-tooltip :text="`${item.attachments.length} ${$t('bug_file')}`">
                        <feather-icon v-if="item.attachments.length" class="mr-3" icon="FileIcon"/>
                    </vx-tooltip>
                    <vx-tooltip :text="item.url">
                        <feather-icon class="mr-3" icon="LinkIcon"/>
                    </vx-tooltip>
                    <span>{{$t('created')}}:</span> {{dateReplace}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        user() {
            return this.$store.state.user.user
        },
        dateReplace() {
            // Меняем формат даты
            return this.$moment(this.item.created).format('DD MM YYYY H:mm')
        },
        userName() {
            // Если текущий язык английский, подставляем имя на англ
            if(this.$i18n.locale === 'en') {
                // Если имя на англ пустое, используем рус имя
                if(this.item.author.profile.first_name_en)
                    return `${ this.item.author.profile.last_name_en } ${ this.item.author.profile.first_name_en }`
                else
                    return `${ this.item.author.profile.lastName } ${ this.item.author.profile.firstName } ${ this.item.author.profile.middleName }`
            } else
                return `${ this.item.author.profile.lastName } ${ this.item.author.profile.firstName } ${ this.item.author.profile.middleName }`
        },
        userName2() {
            // Если текущий язык английский, подставляем имя на англ
            if(this.$i18n.locale === 'en') {
                // Если имя на англ пустое, используем рус имя
                if(this.item.responsible_person.user.profile.first_name_en)
                    return `${ this.item.responsible_person.user.profile.last_name_en } ${ this.item.responsible_person.user.profile.first_name_en }`
                else
                    return `${ this.item.responsible_person.user.profile.lastName } ${ this.item.responsible_person.user.profile.firstName }`
            } else
                return `${ this.item.responsible_person.user.profile.lastName } ${ this.item.responsible_person.user.profile.firstName }`
        },
        statusText() {
            switch (this.item.status) {
            case 1:
                return this.$t('new_bug')
                break;
            case 2:
                return this.$t('in_work')
                break;
            case 3:
                return this.$t('performed')
                break;
            }
        },
        statusColor() {
            switch (this.item.status) {
            case 1:
                return 'primary'
                break;
            case 2:
                return 'warning'
                break;
            case 3:
                return 'success'
                break;
            }
        }
    }
}
</script>
